import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import DashboardLayout from 'src/layouts/dashboard';
import { LoadingScreen } from 'src/components/loading-screen';
import CustomerListPage from 'src/pages/dashboard/customer/list';
import OrderListPage from 'src/pages/dashboard/order/list';
import CountryListPage from 'src/pages/dashboard/country/list';
import BranchListPage from 'src/pages/dashboard/branch/list';
import KanbanListPage from 'src/pages/dashboard/kanban/list';
import AirwayBillListPage from 'src/pages/dashboard/airWaybill/list';
import BoxListPage from 'src/pages/dashboard/box/lits';
import PalleteListPage from 'src/pages/dashboard/pallete/list';
import ShelfListPage from 'src/pages/dashboard/shelf/list';
import WarehouseLocationListPage from 'src/pages/dashboard/warehouseLocation/list';
import AddressListPage from 'src/pages/dashboard/address/list';
import TimeSlotListPage from 'src/pages/dashboard/timeSlots/list';
import StatusUpdateList from 'src/pages/dashboard/statusUpdate/list';
import CheckOrderList from 'src/pages/dashboard/checkOrder/list';
import PhysicalCheckoutListPage from 'src/pages/dashboard/physicalCheckout/list';
import DeliveryAreaListPage from 'src/pages/dashboard/deliveryArea/list';
import ContentManagementList from 'src/pages/dashboard/contentManagement/list';
import RSListPage from 'src/pages/dashboard/rs/list';
import PriceListPage from 'src/pages/dashboard/prices/list';
import PaymentListPage from 'src/pages/dashboard/payments/list';
import GeorgianPhysicalPaymentPage from 'src/pages/dashboard/payments/georgian-physical-payments';
import LiveOrdersListPage from 'src/pages/dashboard/liveOrders/list';
import InvoiceListPage from 'src/pages/dashboard/invoice/list';
// import CustomOrdersListPage from 'src/pages/dashboard/customOrders/list';
import InvoicePerID from 'src/sections/invoice/invoiceView';

import InventarizationListPage from 'src/pages/dashboard/inventarization/list';
import RecieverListPage from 'src/pages/dashboard/reciever/list';
import PhysicalOrderListPage from 'src/pages/dashboard/ordersPhysical/list';

import { jwtDecode } from 'jwt-decode';
import {
  OrderProvider,
  BranchProvider,
  CountryProvider,
  CustomerProvider,
  BoxProvider,
  PalletProvider,
  ShelfProvider,
  ImageUploadProvider,
  ContentProvider,
  AirwayBillProvider,
  AddressProvider,
  PriceProvider,
  PaymentProvider,
  RecieverProvider,
  TermsAndConditionsProvider,
  DeliveryAreaProvider,
} from '../../context/providers';
import TermsAndConditionsListPage from '../../pages/dashboard/termsAndConditions/list';

const auth = JSON.parse(localStorage.getItem('token'));

// Helper function to wrap providers
function wrapProviders(component) {
  return (
    <BoxProvider>
      <PaymentProvider>
        <PalletProvider>
          <PriceProvider>
            <ShelfProvider>
              <OrderProvider>
                <ImageUploadProvider>
                  <RecieverProvider>
                    <BranchProvider>
                      <CustomerProvider>
                        <ContentProvider>
                          <AirwayBillProvider>
                            <AddressProvider>
                              <TermsAndConditionsProvider>
                                <DeliveryAreaProvider>
                                  <CountryProvider>{component}</CountryProvider>
                                </DeliveryAreaProvider>
                              </TermsAndConditionsProvider>
                            </AddressProvider>
                          </AirwayBillProvider>
                        </ContentProvider>
                      </CustomerProvider>
                    </BranchProvider>
                  </RecieverProvider>
                </ImageUploadProvider>
              </OrderProvider>
            </ShelfProvider>
          </PriceProvider>
        </PalletProvider>
      </PaymentProvider>
    </BoxProvider>
  );
}

let routChildren = [];
let routChildInvoice = [];

if (auth) {
  const decoded = jwtDecode(auth);
  if (decoded.location === 'China') {
    routChildren = [
      { element: <Navigate to="customer" />, index: true },
      {
        path: 'customer',
        children: [
          { element: <CustomerListPage />, index: true },
          { path: ':customer_id', element: <CustomerListPage /> },
        ],
      },
      { element: <Navigate to="orders" />, index: true },
      {
        path: 'orders',
        children: [
          { element: <OrderListPage />, index: true },
          { path: ':order_id', element: <OrderListPage /> },
        ],
      },
      {
        path: 'kanban',
        children: [{ element: <KanbanListPage />, index: true }],
      },
      {
        path: 'OrderStatus',
        children: [{ element: <StatusUpdateList />, index: true }],
      },
      {
        path: 'box',
        children: [{ element: <BoxListPage />, index: true }],
      },
      {
        path: 'pallet',
        children: [{ element: <PalleteListPage />, index: true }],
      },
      {
        path: 'airwayBill',
        children: [{ element: <AirwayBillListPage />, index: true }],
      },
    ];
  }
  if (decoded.location === 'USA') {
    routChildren = [
      { element: <Navigate to="customer" />, index: true },
      {
        path: 'customer',
        children: [
          { element: <CustomerListPage />, index: true },
          { path: ':customer_id', element: <CustomerListPage /> },
        ],
      },
      {
        path: 'receiver',
        children: [
          { element: <RecieverListPage />, index: true },
          { path: ':customer_id', element: <RecieverListPage /> },
        ],
      },
      {
        path: 'orders',
        children: [
          { element: <OrderListPage />, index: true },
          { path: ':order_id', element: <OrderListPage /> },
        ],
      },
      {
        path: 'ordersPhisical',
        children: [
          { element: <PhysicalOrderListPage />, index: true },
          { path: ':order_id', element: <PhysicalOrderListPage /> },
        ],
      },
      {
        path: 'delivery-areas',
        children: [{ element: <DeliveryAreaListPage />, index: true }],
      },
      {
        path: 'georgian-physical-payments',
        children: [
          { element: <GeorgianPhysicalPaymentPage />, index: true },
          { path: ':payment_id', element: <GeorgianPhysicalPaymentPage /> },
        ],
      },
      {
        path: 'kanban',
        children: [{ element: <KanbanListPage />, index: true }],
      },
      {
        path: 'OrderStatus',
        children: [{ element: <StatusUpdateList />, index: true }],
      },
      {
        path: 'box',
        children: [{ element: <BoxListPage />, index: true }],
      },
      {
        path: 'pallet',
        children: [{ element: <PalleteListPage />, index: true }],
      },
      {
        path: 'airwayBill',
        children: [{ element: <AirwayBillListPage />, index: true }],
      },
    ];
  }
  if (decoded.location === 'Georgia') {
    routChildren = [
      { element: <Navigate to="customer" />, index: true },
      {
        path: 'customer',
        children: [
          { element: <CustomerListPage />, index: true },
          { path: ':customer_id', element: <CustomerListPage /> },
        ],
      },
      {
        path: 'receiver',
        children: [
          { element: <RecieverListPage />, index: true },
          { path: ':customer_id', element: <RecieverListPage /> },
        ],
      },
      {
        path: 'customer-address-details',
        children: [{ element: <CustomerListPage />, index: true }],
      },

      {
        path: 'payments',
        children: [
          { element: <PaymentListPage />, index: true },
          { path: ':payment_id', element: <PaymentListPage /> },
        ],
      },
      {
        path: 'delivery-areas',
        children: [{ element: <DeliveryAreaListPage />, index: true }],
      },
      {
        path: 'georgian-physical-payments',
        children: [
          { element: <GeorgianPhysicalPaymentPage />, index: true },
          { path: ':payment_id', element: <GeorgianPhysicalPaymentPage /> },
        ],
      },
      {
        path: 'orders',
        children: [
          { element: <OrderListPage />, index: true },
          { path: ':order_id', element: <OrderListPage /> },
        ],
      },
      {
        path: 'ordersPhisical',
        children: [
          { element: <PhysicalOrderListPage />, index: true },
          { path: ':order_id', element: <PhysicalOrderListPage /> },
        ],
      },
      {
        path: 'branch',
        children: [{ element: <BranchListPage />, index: true }],
      },
      {
        path: 'country',
        children: [{ element: <CountryListPage />, index: true }],
      },
      {
        path: 'kanban',
        children: [{ element: <KanbanListPage />, index: true }],
      },
      {
        path: 'box',
        children: [{ element: <BoxListPage />, index: true }],
      },
      {
        path: 'pallet',
        children: [{ element: <PalleteListPage />, index: true }],
      },
      {
        path: 'shelf',
        children: [{ element: <ShelfListPage />, index: true }],
      },
      {
        path: 'WarehouseLocation',
        children: [{ element: <WarehouseLocationListPage />, index: true }],
      },
      {
        path: 'TimeSlot',
        children: [{ element: <TimeSlotListPage />, index: true }],
      },
      {
        path: 'OrderStatus',
        children: [{ element: <StatusUpdateList />, index: true }],
      },
      {
        path: 'OrderCheck',
        children: [{ element: <CheckOrderList />, index: true }],
      },
      {
        path: 'physical-checkout',
        children: [{ element: <PhysicalCheckoutListPage />, index: true }],
      },
      {
        path: 'terms-and-conditions',
        children: [{ element: <TermsAndConditionsListPage />, index: true }],
      },
      {
        path: 'ContentManagement',
        children: [{ element: <ContentManagementList />, index: true }],
      },
      {
        path: 'airwayBill',
        children: [{ element: <AirwayBillListPage />, index: true }],
      },
      {
        path: 'address',
        children: [{ element: <AddressListPage />, index: true }],
      },
      {
        path: 'rs',
        children: [{ element: <RSListPage />, index: true }],
      },
      {
        path: 'price',
        children: [{ element: <PriceListPage />, index: true }],
      },
      {
        path: 'liveOrders',
        children: [{ element: <LiveOrdersListPage />, index: true }],
      },
      // {
      //   path: 'customOrders',
      //   children: [{ element: <CustomOrdersListPage />, index: true }],
      // },
      {
        path: 'inventarization',
        children: [{ element: <InventarizationListPage />, index: true }],
      },
      {
        path: 'invoice',
        children: [{ element: <InvoiceListPage />, index: true }],
      },
    ];
  }
  routChildInvoice = [
    {
      path: 'invoice/:id',
      children: [{ element: <InvoicePerID />, index: true }],
    },
  ];
}

export const dashboardRoutes = auth
  ? [
      {
        path: 'dashboard',
        element: (
          <DashboardLayout>
            {wrapProviders(
              <Suspense fallback={<LoadingScreen />}>
                <Outlet />
              </Suspense>
            )}
          </DashboardLayout>
        ),
        children: routChildren,
      },
      {
        path: 'inv',
        children: routChildInvoice,
      },
    ]
  : [];
